'use client';

import { Stack, Text } from '@chakra-ui/react';
import { useTranslations } from 'next-intl';
import { useFormContext } from 'react-hook-form';

import type { ResetPasswordFormModel } from '@/modules/authentication/view-model';

import { Form } from '@packages/hook-form-wrapper';

export const ResetPasswordForm = () => {
	const t = useTranslations('authentication.resetPassword.form');
	const { formState } = useFormContext<ResetPasswordFormModel>();
	const { errors } = formState;

	return (
		<Stack gap="lg">
			<Stack>
				{/* // @ts-expect-error */}
				<Text variant="formLabel">
					{t('title')}
				</Text>
				{errors.oobCode && (
					<Text color="red.500" textStyle="caption">
						{errors.oobCode.message}
					</Text>
				)}
			</Stack>
			<Form.PasswordInput<ResetPasswordFormModel>
				helperText={t('fields.newPassword.helperText')}
				label={t('fields.newPassword.label')}
				name="password"
				placeholder={t('fields.newPassword.placeholder')}
				size="lg"
			/>
			<Form.PasswordInput<ResetPasswordFormModel>
				label={t('fields.confirmNewPassword.label')}
				name="confirmPassword"
				placeholder={t('fields.confirmNewPassword.placeholder')}
				size="lg"
			/>
			<Form.SubmitButton size="lg">
				{t('actions.submit')}
			</Form.SubmitButton>
		</Stack>
	);
};
